import "./src/styles/global.css";
import posthog from "posthog-js";

export const onClientEntry = () => {
  posthog.init(process.env.GATSBY_POSTHOG_KEY, {
    api_host: process.env.GATSBY_POSTHOG_HOST,
    ui_host: "https://us.posthog.com",
    person_profiles: "identified_only",
  });
};
